// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"45310730","426":"cbdb6a57","453":"a04fe25b","528":"cde4cab4","581":"b8f7bcf4","610":"4998bf4f","846":"0ed0bad4","891":"0762ef62","894":"3d4565ee"}[chunkId] + ".chunk.js";
};